import React from 'react'
import PropTypes from 'prop-types'

import TryFreeCta from '@/components/TryFreeCta'
import { Column, Section } from '@/components/layout'
import BuyTry from '@/components/blocks/BuyTry'
import { Text } from '@/components/common'

import styles from './TrackReceiptsHeader.module.scss'

const TrackReceiptsHeader = ({ highlightedText, subHeadline, btnMessageId = '', tryOnly }) => {
  const ctaMessageIdProp = btnMessageId ? { buttonMessageId: btnMessageId } : {}

  return (
    <Section bgForeground paddingVertical={0} wrapperClassName={styles.wrapper}>
      <Column className="w-full">
        <div className={styles.heroHolder}>
          <div className="max-w-700">
            <Text.H1 brandSecondary normal size="medium">Receipt Scanner App</Text.H1>
            <Text bold className={styles.tagline} noMargin onTint size="large" type="display">The All-In-One Receipt Scanner App to Track, Organize, and Manage Your Expenses</Text>
            <Text.P onTint>{ subHeadline || 'Effortlessly keep your books neat. No accounting expertise required.' }</Text.P>
            {highlightedText && <Text.P className={styles.yellowText} onTint>{highlightedText}</Text.P>}
            {tryOnly ? <TryFreeCta {...ctaMessageIdProp} /> : <BuyTry justifyStart marginTop={32} noOutline />}
            <Text.P onTint size="xsmall">Neat is a yearly subscription where you can add on solutions.</Text.P>
          </div>
        </div>
      </Column>
    </Section>
  )
}

TrackReceiptsHeader.propTypes = {
  btnMessageId: PropTypes.string,
  subHeadline: PropTypes.string,
  highlightedText: PropTypes.string,
  tryOnly: PropTypes.bool,
}

export default TrackReceiptsHeader
